import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    fieldsTerraceShapeDimension,
    fieldsTerraceWoodMaterial,
    fieldsTerraceDeckBoardShape,
    fieldTerraceDeckBoardWidth,
    fieldsTerraceObstacleConstraints,
} from './common/fieldsTerrace';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';

const TerraceWoodForm: IForm = {
    formId       : PublishedFormId.TerraceWood,
    type         : FormTypeId.Terrace,
    thumbnailURL : '/resized-images/forms/terrace.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ShapeDimension,
        IFormFieldKey.TerracePedestals,
        IFormFieldKey.Material,
        IFormFieldKey.DeckBoardShape,
        IFormFieldKey.DeckBoardWidth,
        IFormFieldKey.TerraceLight,
        IFormFieldKey.Constraints,
        IFormFieldKey.TerraceLaying,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        shapeDimension   : fieldsTerraceShapeDimension,
        terracePedestals : {
            value: undefined,
        },
        material       : fieldsTerraceWoodMaterial,
        deckBoardShape : fieldsTerraceDeckBoardShape,
        deckBoardWidth : fieldTerraceDeckBoardWidth,
        terraceLight   : {
            value: undefined,
        },
        constraints   : fieldsTerraceObstacleConstraints,
        terraceLaying : {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 30000,
            budgetDefaultValue : 9000,
            budgetStep         : 500,
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default TerraceWoodForm;
